<template>
<div class="body1">
 <el-form  :model="form1" :rules="rules" ref="form1" label-width="100px" class="demo-ruleForm">
  <el-form-item label="企业名称" prop="eName">
    <el-input v-model="form1.eName"></el-input>
  </el-form-item>
   <el-form-item label="统一社会信用代码" prop="eCode">
    <el-input v-model="form1.eCode"></el-input>
  </el-form-item>
   <el-form-item label="法定代表人" prop="jperson">
    <el-input v-model="form1.jperson"></el-input>
  </el-form-item>
   <el-form-item label="联系电话" prop="tel">
    <el-input v-model="form1.tel"></el-input>
  </el-form-item>

  <el-form-item label="行业">
    <el-col :span="12">
      <el-input   v-model="form1.indName" style="width: 100%;"></el-input>
    </el-col>
    <el-col :span="12">
      <el-input  v-model="form1.indSubname" style="width: 100%;"></el-input>
    </el-col>
  </el-form-item>

   <el-form-item label="省市区">
    <el-col :span="8">
      <el-input   v-model="form1.provName" style="width: 100%;"></el-input>
    </el-col>
    <el-col :span="8">
      <el-input  v-model="form1.cityName" style="width: 100%;"></el-input>
    </el-col>
     <el-col :span="8">
      <el-input  v-model="form1.distName" style="width: 100%;"></el-input>
    </el-col>
  </el-form-item>

   <el-form-item label="创建时间" prop="createTime" required>
    <el-col :span="11">
      <el-form-item prop="appraiseDate">
        <el-date-picker type="date" placeholder="创建时间" v-model="form1.createTime" style="width: 100%;"></el-date-picker>
      </el-form-item>
    </el-col>
  </el-form-item>

  <el-form-item>
    <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
    <el-button @click="resetForm('ruleForm')">返回</el-button>
  </el-form-item>
</el-form>
   </div>
</template>

<script>
export default {
  name: 'creditadd',
  data () {
    return {
      form1: {
        eName: '',
        eCode: '',
        jperson: '',
        tel: '',
        createTime: '',
        updateTime: '',
        indName: '',
        indSubname: '',
        provName: '',
        cityName: '',
        distName: ''
      },
      rules: {
        eName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' }
        ],
        eCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' }
        ],
        jperson: [
          { required: true, message: '请输入法定代表人', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        createTime: [
          { type: 'date', required: true, message: '请输入创建时间', trigger: 'change' }
        ],
        updateTime: [
          { type: 'date', required: true, message: '请输入修改时间', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    }
  }
}
</script>

<style scoped>
.body1{
  width:600px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/creditadd.vue